function Safe({
  color = 'currentColor',
  size = 21,
  strokeWidth = 0.670909
}: {
  color?: string
  size?: number
  strokeWidth?: number
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 21 20" fill="none">
      <path d="M5.5 17.5H8M13 17.5H15.5M15.0833 5.41667V12.0833M3 5.16667L3 12.3333C3 13.2668 3 13.7335 3.18166 14.09C3.34144 14.4036 3.59641 14.6586 3.91002 14.8183C4.26654 15 4.73325 15 5.66667 15L15.3333 15C16.2668 15 16.7335 15 17.09 14.8183C17.4036 14.6586 17.6586 14.4036 17.8183 14.09C18 13.7335 18 13.2668 18 12.3333V5.16667C18 4.23325 18 3.76654 17.8183 3.41002C17.6586 3.09641 17.4036 2.84145 17.09 2.68166C16.7335 2.5 16.2668 2.5 15.3333 2.5L5.66667 2.5C4.73325 2.5 4.26654 2.5 3.91002 2.68166C3.59641 2.84144 3.34144 3.09641 3.18166 3.41002C3 3.76654 3 4.23325 3 5.16667ZM10.0833 8.75C10.0833 9.90059 9.15059 10.8333 8 10.8333C6.84941 10.8333 5.91667 9.90059 5.91667 8.75C5.91667 7.59941 6.84941 6.66667 8 6.66667C9.15059 6.66667 10.0833 7.59941 10.0833 8.75Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default Safe
